import { useEffect, useState } from 'react';
import { usePsaStore } from '@/store/zustand/psa-store';
import { usePageScrolled } from '@/hooks/usePageScrolled';
import { calculatePsaNavTopOffset } from '@/utils/utils';

const usePsaTopOffset = (calculationOffset?: number) => {
  const offset = calculationOffset ? calculationOffset : 0;
  const [topOffset, setTopOffset] = useState(0);
  const { isShown } = usePsaStore();
  const isScrolled = usePageScrolled(offset);

  useEffect(() => {
    // deducting 5 pixels to be sure there is no line showing
    setTopOffset(calculatePsaNavTopOffset() - 3);
  }, [isShown, isScrolled]);

  return topOffset;
};

export default usePsaTopOffset;
